module.exports = __webpack_public_path__ + "img/triangulo.53d97958.png";